
export function AddressDisplayDirective(): ng.IDirective {
  return {
    restrict: 'E',
    scope: {
      address: '=address'
    },
    template: function() {
      return `
        <span>
          {{address.addressLine1}}{{address.addressLine2 ? ' ' + address.addressLine2 : ''}},
          {{address.city}},
          {{address.state}},
          {{address.zipCode}}
        </span>
      `;
    },
  };
}
